import { useT } from "../../../core/i18n";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";

import {
  getReportingEmployees,
  assignShift,
  getMyAttendanceList,
} from "../../../core/data/redux/reportingEmployeesSlice";
import { useDispatch, useSelector } from "react-redux";
import Toasts from "../../../core/common/toast";
import { Avatar } from "antd";
import dayjs from "dayjs";

import ReportingAttendence from "../reportingAttendence";
import ReportingShift from "../reportingShift";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AttendanceDetailsModel from "../../../core/modals/attendanceDetailsModel";
import { DatePicker } from "antd";
import { ConfigProvider } from "antd";
interface ReportingEmployeesProps { }

const ReportingEmployees = (props: ReportingEmployeesProps) => {
  const { t } = useT();
  const navigate = useNavigate();

  const reportingEmployeesState = useSelector(
    (state: any) => state.reportingEmployeesState
  );

  const [currentItem, setCurrentItem] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const [dataList, setDataList] = React.useState<any[]>([]);
  const routes = all_routes;
  const [query, setQuery] = useState<any>("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });
  const [filterEmpId, setFilterEmpId] = useState<string>("");
  const [fromDate, setFromDate] = useState<dayjs.Dayjs | null>(null);
  const [toDate, setToDate] = useState<dayjs.Dayjs | null>(null);

  const fetchRecords = (pagination: any, query: string) => {
    dispatch(
      getMyAttendanceList({
        page: pagination.current,
        limit: pagination.pageSize,
        query: query,
      })
    );
  };

  const handleSearch = (query: string) => {
    fetchRecords(pagination, query);
  };

  React.useEffect(() => {
    fetchRecords(pagination, query);
  }, []);

  React.useEffect(() => {
    if (
      reportingEmployeesState.loading === "fulfilled" &&
      reportingEmployeesState.action === "assign"
    ) {
      fetchRecords(pagination, query);
    } else if (
      reportingEmployeesState.loading === "fulfilled" &&
      reportingEmployeesState.action === "list"
    ) {
      const result = reportingEmployeesState?.data?.data || null;
      if (result?.data && result?.data?.length > 0) {
        const employees = result?.data || [];
        setDataList(employees);
        setPagination({
          ...pagination,
          total: result.total || employees.length,
          current: result.page || 1,
          pageSize: result.limit || 10,
        });
      } else {
        setDataList([]);
      }
    }
  }, [reportingEmployeesState.loading]);

  // Calculate statistics from dataList
  const statistics = React.useMemo(() => {
    const presence = dataList.filter((item: any) => item.attendance_status === 'PRESENT').length;
    const absence = dataList.filter((item: any) => item.attendance_status === 'ABSENT').length;
    const halfDay = dataList.filter((item: any) => item.attendance_status === 'HALF_DAY').length;
    const lateComing = dataList.filter((item: any) => item.attendance_status === 'LATE_COMING').length;
    const earlyLeaving = dataList.filter((item: any) => item.attendance_status === 'EARLY_LEAVING').length;
    const holiday = dataList.filter((item: any) => item.attendance_status === 'HOLIDAY').length;

    return { presence, absence, halfDay, lateComing, earlyLeaving, holiday };
  }, [dataList]);

  const getStatusColor = (status: string) => {
    const colors: Record<string, string> = {
      PRESENT: "#049123",
      ABSENT: "#C0282C",
      HALF_DAY: "#FFA500",
      LATE_COMING: "#B09BFB",
      EARLY_LEAVING: "#FFFF00",
      HOLIDAY: "#969696",
    };
    return colors[status] || "#ccc";
  };


  const showLocation = (record: any) => {
    setCurrentItem(record);
    setShowModal(true);
  }
  const columns = [
    {
      title: t("sr_no"),
      render: (_: any, __: any, index: number) =>
        index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      title: t("office_name"),
      render: (record: any) =>
        record?.officeLocation?.name ? record.officeLocation.name : "-",
    },

    {
      title: t("check_in"),
      dataIndex: "check_in_time",
      render: (text: string) => new Date(text).toLocaleString(),
    },

    {
      title: t("check_in_location"),
      dataIndex: "check_in_latitude",
      render: (text: string, record: any) => (
        <div>
          <Link to={"#"} className="text-decoration-none" onClick={() => showLocation(record)}>
            <div><b>Latitude</b>: {record.check_in_latitude}</div>
            <div><b>Longitude</b>: {record.check_in_longitude}</div>
          </Link>
        </div>
      )
    },

    {
      title: t("check_out"),
      dataIndex: "check_out_time",
      render: (text: string) => new Date(text).toLocaleString(),
    },
    {
      title: t("working_hours"),
      dataIndex: "working_hours",
    },

    {
      title: t("attendance_status"),
      dataIndex: "attendance_status",
      render: (text: string) => (
        <span
          style={{
            backgroundColor: getStatusColor(text),
            color: "#fff",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
          }}
        >
          {text?.replace(/_/g, " ")?.replace(/\b\w/g, (c) => c.toUpperCase())}
        </span>
      ),
    },
    {
      title: t("verified"),
      dataIndex: "is_verified",
    },
  ];

  const handlePagination = (pagination: any) => {
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    fetchRecords(pagination, query);
  };

  return (
    <div>
      <>
        <Toasts
          show={reportingEmployeesState.loading === "rejected"}
          message={reportingEmployeesState.error}
          title={"Failed"}
          type={"danger"}
        />
        <Toasts
          show={
            reportingEmployeesState.loading === "fulfilled" &&
            reportingEmployeesState.action != "list"
          }
          message={reportingEmployeesState?.data?.message}
          title={"Success"}
          type={"success"}
        />
        <div className="page-wrapper">
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Attendence Regularize</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Employees</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Attendence Regularize
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            {/* Summary Cards */}
            <div className="row mb-4">
              <div className="col-md-2 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm" style={{ borderRadius: "8px" }}>
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2" style={{ fontSize: "13px", fontWeight: "500" }}>Presence</h6>
                        <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600", color: "#333" }}>{statistics.presence}</h3>
                        <small className="text-muted" style={{ fontSize: "11px" }}>Days</small>
                      </div>
                      <div className="avatar avatar-md rounded-circle" style={{ backgroundColor: "#E8F5E9", width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="ti ti-user-check fs-20" style={{ color: "#049123" }}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm" style={{ borderRadius: "8px" }}>
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2" style={{ fontSize: "13px", fontWeight: "500" }}>Absence</h6>
                        <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600", color: "#333" }}>{statistics.absence}</h3>
                        <small className="text-muted" style={{ fontSize: "11px" }}>Days</small>
                      </div>
                      <div className="avatar avatar-md rounded-circle" style={{ backgroundColor: "#FFEBEE", width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="ti ti-user-x fs-20" style={{ color: "#C0282C" }}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm" style={{ borderRadius: "8px" }}>
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2" style={{ fontSize: "13px", fontWeight: "500" }}>Half Day</h6>
                        <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600", color: "#333" }}>{statistics.halfDay}</h3>
                        <small className="text-muted" style={{ fontSize: "11px" }}>Days</small>
                      </div>
                      <div className="avatar avatar-md rounded-circle" style={{ backgroundColor: "#F5F5F5", width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="ti ti-clock-hour-4 fs-20" style={{ color: "#666" }}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm" style={{ borderRadius: "8px" }}>
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2" style={{ fontSize: "13px", fontWeight: "500" }}>Late Coming</h6>
                        <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600", color: "#333" }}>{statistics.lateComing}</h3>
                        <small className="text-muted" style={{ fontSize: "11px" }}>Days</small>
                      </div>
                      <div className="avatar avatar-md rounded-circle" style={{ backgroundColor: "#F3E5F5", width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="ti ti-clock-exclamation fs-20" style={{ color: "#B09BFB" }}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm" style={{ borderRadius: "8px" }}>
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2" style={{ fontSize: "13px", fontWeight: "500" }}>Early Leaving</h6>
                        <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600", color: "#333" }}>{statistics.earlyLeaving}</h3>
                        <small className="text-muted" style={{ fontSize: "11px" }}>Days</small>
                      </div>
                      <div className="avatar avatar-md rounded-circle" style={{ backgroundColor: "#FFF9C4", width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="ti ti-clock-minus fs-20" style={{ color: "#F57C00" }}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm" style={{ borderRadius: "8px", backgroundColor: "#9E9E9E" }}>
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="mb-2" style={{ fontSize: "13px", fontWeight: "500", color: "#fff" }}>Holiday</h6>
                        <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600", color: "#fff" }}>{statistics.holiday}</h3>
                        <small style={{ fontSize: "11px", color: "rgba(255,255,255,0.8)" }}>Days</small>
                      </div>
                      <div className="avatar avatar-md rounded-circle" style={{ backgroundColor: "rgba(255,255,255,0.2)", width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="ti ti-calendar-event fs-20" style={{ color: "#fff" }}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                <h4 className="mb-4 mt-3">Attendence Regularize List</h4>
                <div className="d-flex align-items-center gap-2 mb-4 mt-3" style={{ flexWrap: 'nowrap' }}>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    style={{
                      maxWidth: '200px',
                      height: '31px',
                      lineHeight: '31px',
                      position: 'relative',
                      top: "-3px",
                      padding: '0.25rem 0.5rem'
                    }}
                    placeholder={t("search_by_emp_id")}
                    value={filterEmpId}
                    onChange={(e) => setFilterEmpId(e.target.value)}
                  />
                  <ConfigProvider>
                    <DatePicker
                      size="small"
                      style={{ maxWidth: '150px', height: '31px' }}
                      placeholder={t("from_date")}
                      format="DD-MM-YYYY"
                      value={fromDate}
                      onChange={(date) => setFromDate(date)}
                    />
                  </ConfigProvider>
                  <ConfigProvider>
                    <DatePicker
                      size="small"
                      style={{ maxWidth: '150px', height: '31px' }}
                      placeholder={t("to_date")}
                      format="DD-MM-YYYY"
                      value={toDate}
                      onChange={(date) => setToDate(date)}
                      disabledDate={(current) => {
                        if (!fromDate) return false;
                        return current && current < fromDate.startOf("day");
                      }}
                    />
                  </ConfigProvider>
                  <div className="d-flex gap-2" style={{ position: "relative", top: "-2px" }}>
                    <button
                      type="button"
                      className="btn btn-info btn-sm"
                      style={{ height: '31px', lineHeight: '1', padding: '0.25rem 0.75rem' }}
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      style={{ height: '31px', lineHeight: '1', padding: '0.25rem 0.75rem' }}
                      onClick={() => {
                        setFilterEmpId("");
                        setFromDate(null);
                        setToDate(null);
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body p-0 py-3">
                <Table
                  columns={columns}
                  dataSource={dataList}
                  Selection={false}
                  paginationConfig={pagination}
                  handlePagination={handlePagination}
                  loading={reportingEmployeesState.loading === "pending"}
                  handleSearch={handleSearch}
                />
              </div>
            </div>
          </div>
        </div>
      </>
      {currentItem && <AttendanceDetailsModel show={showModal} item={currentItem} close={() => {
        setShowModal(false);
        setCurrentItem(null);
      }} />
      }
    </div>
  );
};

export default ReportingEmployees;
